import {ref} from "vue";
import axios, {AxiosError} from "axios";
import {Config, IAuthPlugin} from "@/plugins/auth/auth";
import {Drivers, Storage} from "@ionic/storage";
import {Device} from "@capacitor/device";
import {CapacitorHttp} from "@capacitor/core";
import LocalStorage from "@/services/LocalStorage";


export default {
    install(app: any) {
        app.provide('storage', {
            getInstance(): Promise<Storage> {
                const store = new Storage({
                    name: '__arabtest',
                    driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage]
                });

                return store.create();
            }
        })
        app.provide('backdrop', {
            show: ref(false),
            toggle(): void {
                this.show.value = !this.show.value;
            },
            setShow(show: boolean): boolean {
                this.show.value = show;
                return this.show.value;
            }

        })
        app.provide('auth', {
            user: ref("HOLA"),
            async isAuthenticated(): Promise<boolean> {
                const config = await LocalStorage.getItem('config');
                const token = await LocalStorage.getItem('token');
                const username = await LocalStorage.getItem('username');
                const password = await LocalStorage.getItem('password');

                if (config == null || token == null) {
                    return false;
                }

                if (username === null || password === null) {
                    await LocalStorage.clear();
                    return false;
                }

                const result = await this.validateToken(token);
                console.debug('Resultado de la validación del token: ' + result);
                if (result === true || result === false) {
                    // No es modo mantenimiento
                    return result;
                } else {

                    const error = result as AxiosError;

                    if (error.status == 503 || error.status == 422 || error.status == 401) {
                        return {
                            'response': error.response,
                            'status': error.status,
                        };
                    } else {
                        console.error(error);
                        return false;
                    }

                }
            },
            async validateToken(token: string): Promise<boolean | AxiosError> {
                console.debug('Validando token ' + token);
                const config = {
                    method: 'GET',
                    maxBodyLength: Infinity,
                    url: import.meta.env.VITE_BACKEND_URL + '/sanctum/validate',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    data: JSON.stringify({
                        token: token
                    }),

                };

                try {
                    const response = await axios.request(config);
                    return true;
                } catch (error: AxiosError) {
                    await LocalStorage.removeItem('token');
                    await LocalStorage.removeItem('config');
                    return false;
                }
            },
            async login(username: string, password: string): Promise<boolean | AxiosError> {

                await LocalStorage.setItem('username', username);
                await LocalStorage.setItem('password', password);

                const uuid = await Device.getId();
                const {platform, operatingSystem, osVersion, model} = await Device.getInfo();

                const data = JSON.stringify({
                    "username": `${username}`,
                    "password": `${password}`,
                    "device_name": '',
                    "device_id": uuid.identifier,
                    "ip_address": "",
                    "mac_address": "",
                    "device_model": `${model} (${osVersion})`,
                    "device_platform": platform,
                    "device_os": operatingSystem
                });

                const config = {
                    method: 'POST',
                    maxBodyLength: Infinity,
                    url: import.meta.env.VITE_BACKEND_URL + '/sanctum/token',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    data: data
                };


                try {
                    const response = await CapacitorHttp.post(config);

                    if (response.status == 503) {
                        throw {
                            response: response
                        };
                    }

                    if (response.status == 422) {
                        throw {
                            response: response
                        };
                    }

                    const dataResponse = response.data;


                    const user = dataResponse.user;
                    if (user === null || user?.enabled === false) {
                        return false;
                    }

                    await LocalStorage.setItem('token', dataResponse.token);
                    await LocalStorage.setItem('config', JSON.stringify({
                        ...dataResponse.config,
                        user: dataResponse.user
                    }));


                    return true;
                } catch (error: any) {

                    if (error.response.status == 503) {
                        return error;
                    }

                    if (error.response.status == 422) {
                        // Número de sesiones maximas alcanzadas
                        const response = error.response.data;
                        const textError = response.errors.message;

                        return error;
                    }
                    return false;
                }


            },
            async getConfig(): Promise<Config | null> {
                const config = await LocalStorage.getItem('config');
                if (config === null) {
                    return null;
                } else {
                    return JSON.parse(config) as Config;
                }
            }
        } as IAuthPlugin);
    }
}
